import { Constant } from "../../Utils/Constant/Constant";

/**
 *
 * * type 0 : is success message
 * * type 1 : is data null message
 * * type 2 : is Error on connection
 * * type 3: is server not connected
 *
 * @param  data :  this will response data
 * @returns : this method will return custom type, data,code
 */
export const ApiErrorHandler = (data, method, error) => {
  const methodTypes = [
    Constant.POST,
    Constant.GET,
    Constant.DELETE,
    Constant.PUT,
  ];

  //! data.data.message?data.data.message:data will be replaced to data.data.message in the future
  if (data && method === Constant.GET) {
    switch (data.status) {
      case 200: {
        return data.data.data
          ? { type: 0, data: data.data.data, message: data.data.message }
          : { type: 1, data: data.data.data, message: data.data.message };
      }
      case 400: {
        return {
          type: 2,
          data: data.data.data,
          message: data.data.message ? data.data.message : data.data,
        };
      }
      default: {
        return {
          type: 3,
          data: data.data.data,
          message:'server-error',
        };
      }
    }
  } else if (data && methodTypes.includes(method)) {
    switch (data.status) {
      case 200: {
        return {
          type: 0,
          data: data.data.data,
          message: data.data.message ? data.data.message : data.data,
        };
      }
      case 400: {
        return {
          type: 2,
          data: data.data.data,
          message: data.data.message ? data.data.message : data.data,
        };
      }
      default: {
        return {
          type: 3,
          data: data.data.data,
          message: 'server-error',
        };
      }
    }
  } else if (data === undefined) {
    // incase of server error
    return { type: 3, data: "", message: "server-error" };
  }
};
